import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import HeroSection from '@/components/landing/hero-section'
import KeycapRingSection from '@/components/landing/keycap-ring-section'
import SwitchSection from '@/components/landing/switch-section'
import FeaturesSection from '@/components/landing/features-section'
import DeskSection from '@/components/landing/desk-section'
import SpecsSection from '@/components/landing/specs-section'

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo />

            <HeroSection />
            <KeycapRingSection />
            <SwitchSection />
            <FeaturesSection />
            <DeskSection />
            <SpecsSection />
        </Layout>
    )
}

export default Home
